import React from 'react'
import { TouchableOpacity, View } from 'react-native'
import styled from 'styled-components/native'

import { Text } from '../../../components/common/Text'

type Variant = 'outline' | 'primary' | 'danger'

/**
 * The compact button used throughout content curation -- rows, section headers
 * and modal footers.
 *
 * components/common/Button wraps react-native-elements with 24px of horizontal
 * padding and a heavy dark fill, which reads as a page-level call to action.
 * Repeated per row it dominates a table, and in a modal footer it is louder
 * than the content it acts on.
 */
const Shell = styled(View)<{ variant: Variant; faded: boolean }>`
  border-width: 1px;
  border-radius: 6px;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 12px;
  padding-right: 12px;
  opacity: ${props => (props.faded ? 0.4 : 1)};
  border-color: ${props =>
    props.variant === 'primary'
      ? props.theme.colors.buttonBackground
      : props.variant === 'danger'
      ? props.theme.colors.danger
      : props.theme.colors.border};
  background-color: ${props =>
    props.variant === 'primary'
      ? props.theme.colors.buttonBackground
      : props.variant === 'danger'
      ? props.theme.colors.danger
      : props.theme.colors.appBackground};
`

interface SmallButtonProps {
  label: string
  onPress: () => void
  disabled?: boolean
  variant?: Variant
}

export const SmallButton = ({
  label,
  onPress,
  disabled = false,
  variant = 'outline'
}: SmallButtonProps) => (
  <TouchableOpacity onPress={onPress} disabled={disabled}>
    <Shell variant={variant} faded={disabled}>
      <Text
        styles={{
          fontSize: 13,
          lineHeight: 16,
          color: variant === 'outline' ? '#21201B' : '#FFF'
        }}
      >
        {label}
      </Text>
    </Shell>
  </TouchableOpacity>
)

export default SmallButton
